import React from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Post } from '../../types/content';
type PostCardProps = {
  post: Post;
  featured?: boolean;
};
export function PostCard({
  post,
  featured = false
}: PostCardProps) {
  return <article className={featured ? 'grid gap-8 md:grid-cols-2 md:items-center' : 'flex h-full flex-col'} data-id="element-39" data-mp="3eywjz0tn2unr">
      <Link to={`/blog/${post.slug}`} className="block aspect-[16/10] overflow-hidden bg-ink-surface" tabIndex={-1} aria-hidden="true" data-id="element-40" data-mp="3j0rhdu8g8nw9">
        <img src={post.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out hover:scale-[1.03]" data-id="element-41" data-mp="3ny9ttulodl90" />
      </Link>
      <div className={featured ? '' : 'mt-5 flex flex-1 flex-col'} data-id="element-42" data-mp="1kjesdtbxtan">
        <time dateTime={post.date} className="font-script text-base italic text-ink-muted" data-id="element-43" data-mp="1lui6civ4z18">
          {format(parseISO(post.date), 'MMMM d, yyyy')}
        </time>
        <h3 className={`mt-2 font-slab font-bold uppercase leading-snug tracking-[0.08em] ${featured ? 'text-2xl md:text-3xl' : 'text-lg'}`} data-id="element-44" data-mp="alhmp76w2kyi">
          <Link to={`/blog/${post.slug}`} className="hover:underline hover:underline-offset-4" data-id="element-45" data-mp="1nk3ey45xthrs">
            {post.title}
          </Link>
        </h3>
        <p className={`mt-3 leading-relaxed text-ink-muted ${featured ? '' : 'line-clamp-3 text-sm'}`} data-id="element-46" data-mp="1dpbhd0ccuux0">{post.excerpt}</p>
        <Link to={`/blog/${post.slug}`} className={`${featured ? 'mt-6' : 'mt-auto pt-4'} inline-block font-slab text-xs font-bold uppercase tracking-[0.2em] underline-offset-8 hover:underline`} data-id="element-47" data-mp="18r04egqrk4ak">
          Read more
        </Link>
      </div>
    </article>;
}